export const isEmailValid = (email: string): boolean =>
  /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(email ?? '');

export const isPasswordValid = (psw: string): boolean => /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])\S{8,50}$/.test(psw ?? '');

// Port zo zp functions.js — slovenské telefónne číslo vo formáte +421XXXXXXXXX (medzery sa ignorujú)
export const isPhoneNumberValid = (number: string): boolean => /^\+421\d{9}$/.test((number ?? '').replace(/ /g, ''));

// Port zo zp functions.js — IBAN (medzery sa ignorujú)
export const isIBANValid = (iban: string): boolean =>
  /^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}$/.test((iban ?? '').replace(/ /g, ''));
